// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h7m4","icon":"styles_icon__xVuWx"};